import React from "react";

function IconButton(props) {
  let { name, onClick, customStyle, children } = props;

  return (
    <button
      onClick={onClick}
      className={`${customStyle}  bg-[#007E8B] hover:bg-grey text-white font-medium   py-2  rounded flex items-center justify-center   shadow-md hover:bg-[#387171] hover:shadow-lg focus:bg-[#387171] focus:shadow-lg focus:outline-none focus:ring-0 active:bg-[#387171] active:shadow-lg transition duration-150 ease-in-out`}
    >
      <span className="pr-1">{name}</span>
      {children}
    </button>
  );
}

export default IconButton;
